// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1OgN4","Label":"BuildControl_Label__37Ajw","Less":"BuildControl_Less__3jeml","More":"BuildControl_More__1wtlh"};